import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "options", "value", "defaultValue", "valueChange", "onChange", "hideCloseBtn", "clear", "label", "error", "errMessage", "adjustHeight", "removeBorder", "size", "formTitleDirection", "formTitle", "formTitleClassName", "formTitleSlot", "placeholder", "displayEmpty", "max"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "containerClassName", "valueChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useEffect, useState } from 'react';
import { Close } from '@mui/icons-material';
import { Box, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import clsx from 'clsx';
import lodash, { isNumber } from 'lodash';
import { useController } from 'react-hook-form';
import { JoveFormTitleDirectionEnum } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var removeBorderStyles = {
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  }
};
var JoveSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      value = props.value,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      onChange = props.onChange,
      hideCloseBtn = props.hideCloseBtn,
      clear = props.clear,
      label = props.label,
      error = props.error,
      errMessage = props.errMessage,
      adjustHeight = props.adjustHeight,
      removeBorder = props.removeBorder,
      size = props.size,
      _props$formTitleDirec = props.formTitleDirection,
      formTitleDirection = _props$formTitleDirec === void 0 ? JoveFormTitleDirectionEnum.top : _props$formTitleDirec,
      formTitle = props.formTitle,
      formTitleClassName = props.formTitleClassName,
      formTitleSlot = props.formTitleSlot,
      placeholder = props.placeholder,
      displayEmpty = props.displayEmpty,
      max = props.max,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(''),
      uid = _useState[0],
      setUid = _useState[1];

  var _useState2 = useState(defaultValue || (props !== null && props !== void 0 && props.multiple ? [] : '')),
      selectValue = _useState2[0],
      setSelectValue = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    setUid(lodash.uniqueId());
  }, []);
  /**
   * methods
   */

  var selectValueChangeAction = function selectValueChangeAction(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    var selectList = e.target.value;

    if (props !== null && props !== void 0 && props.multiple && isNumber(max) && (selectList === null || selectList === void 0 ? void 0 : selectList.length) > max) {
      return;
    }

    setSelectValue(e.target.value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(e.target.value);
  };

  var cleanAction = function cleanAction(e) {
    var emptyValue = props.multiple ? [] : '';
    e.target.value = emptyValue;
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    setSelectValue(emptyValue);
    clear === null || clear === void 0 ? void 0 : clear();
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(emptyValue);
  };

  var onClickAction = function onClickAction(e) {
    e.stopPropagation();
  };

  var realValue = value === undefined ? selectValue : value === 0 ? value : value || (props !== null && props !== void 0 && props.multiple ? [] : '');
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [formTitleDirection === JoveFormTitleDirectionEnum.top && (formTitleSlot ? formTitleSlot : !!formTitle ? /*#__PURE__*/_jsx(Typography, {
      variant: "subtitle2",
      className: clsx('mb-1 font-bold', formTitleClassName),
      style: {
        color: props !== null && props !== void 0 && props.disabled ? 'rgba(0, 0, 0, 0.38)' : undefined
      },
      children: formTitle
    }) : null), /*#__PURE__*/_jsxs(Box, {
      className: "flex w-full flex-row items-center space-x-2",
      children: [formTitleDirection === JoveFormTitleDirectionEnum.left && (formTitleSlot ? formTitleSlot : /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: clsx('font-bold', formTitleClassName),
        style: {
          color: props !== null && props !== void 0 && props.disabled ? 'rgba(0, 0, 0, 0.38)' : undefined
        },
        children: formTitle
      })), /*#__PURE__*/_jsxs(Box, {
        className: "flex w-0 flex-1 flex-col",
        children: [/*#__PURE__*/_jsxs(FormControl, {
          className: "relative",
          children: [/*#__PURE__*/_jsx(InputLabel, {
            id: uid + '-label',
            sx: _objectSpread({}, adjustHeight && realValue !== 0 && !realValue && {
              top: '50%',
              left: '16px',
              transform: 'translateY(-50%)'
            }),
            size: size,
            children: label ? "".concat(label, " ").concat(rest !== null && rest !== void 0 && rest.required ? '*' : '') : undefined
          }), Boolean(value) && !hideCloseBtn && /*#__PURE__*/_jsx(Box, {
            className: "pointer-events-none absolute z-10 flex h-full w-full flex-row items-center justify-end px-6",
            children: /*#__PURE__*/_jsx(IconButton, {
              className: "pointer-events-auto",
              onClick: cleanAction,
              children: /*#__PURE__*/_jsx(Close, {
                className: "h-5 w-5"
              })
            })
          }), /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, rest), {}, {
            ref: ref,
            id: uid,
            labelId: uid + '-label',
            label: label,
            value: realValue,
            onChange: selectValueChangeAction,
            sx: removeBorder ? removeBorderStyles : undefined,
            size: size,
            placeholder: placeholder,
            onClick: onClickAction,
            displayEmpty: displayEmpty,
            children: (options || []).map(function (item, index) {
              return /*#__PURE__*/_jsx(MenuItem, {
                value: item.value,
                disabled: item.disabled,
                children: item.label
              }, "".concat(item.value, "-").concat(index));
            })
          }))]
        }), error && /*#__PURE__*/_jsx(FormHelperText, {
          error: error,
          children: errMessage
        })]
      })]
    })]
  });
});
export var JoveSelectControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      valueChange = props.valueChange,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var valueChangeAction = function valueChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveSelect, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      valueChange: valueChangeAction,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveSelect;